import { render, staticRenderFns } from "./SettlementsBar.vue?vue&type=template&id=309de814"
import script from "./SettlementsBar.vue?vue&type=script&lang=js"
export * from "./SettlementsBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports